module.exports = __webpack_public_path__ + "img/right.7191dbdc.svg";